import ReactDOM from "react-dom/client";
import {faPencil, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function";
import {getToken, getUserId} from "../auth";
import {convertiIdEscursione} from "../funzioni/funzioni_utili";
import convertDate from "../funzioni/converti_data";
import {DateTime} from "luxon";
import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
/*global $*/
const EscursioniCli=({dati,numeroConto,escursioni})=>{
    function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
    let formattedRowsClienti = []
    useEffect(() => {
        for (let escursione of escursioni) {
        for (let cliente of dati) {
            if (escursione.excursionid === cliente.excursionid) {
                let dati = {
                    nome: cliente.excursioncustomername, id: cliente.excursioncustomerid,
                    costo: cliente.excursioncustomerpaid, pagato: cliente.excursioncustomeradvance, tipo: escursione.excursiontype,
                    data:escursione.excursiondatestart?convertDate(escursione.excursiondatestart).toISO({ includeOffset: false }):null,
                    excursionid:escursione.excursionid
                }
                formattedRowsClienti = [...formattedRowsClienti, dati]
            }
        }
    }
    const allineamento="center"
    $("#gridContainerClienti").dxDataGrid({
      dataSource: formattedRowsClienti,
      columns: [
           {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
           editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 2,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
        {
          dataField: "nome",
          caption: "Nome Cliente",
          hidingPriority:4,

        },
        { dataField: "costo", alignment:allineamento,caption: "Costo cliente", hidingPriority:3,customizeText: function (e){
          return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}
  },
        { dataField: "pagato", alignment:allineamento,caption: "Pagato",hidingPriority:5,customizeText: function (e){
          return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}


        },

          { dataField: "tipo", caption: "Tipo Escursione", alignment:allineamento,hidingPriority: 5,
          customizeText: function (cellInfo) {
          return convertiIdEscursione(cellInfo.value)
          },
          },

        {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica cliente`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "nome","costo","pagato",
                ],
              },
            ],
          },
      },
      onRowInserting: async function (e) {
            let richiesta=null
            const dati2={"excursionid":e.data.excursionid,"excursioncustomeradvance": e.data.pagato,"excursioncustomername":e.data.nome,"excursioncustomerpaid":e.data.costo,"excursioncustomerphone":e.data.telefono,}
             richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati2,
                azione:'setExcursionCust'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `${e.data.nome} aggiunto con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerCusts',

                },}, "success", 1000);
          const clienti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
              filtri:{"billid":numeroConto},
                azione: "getExcursionCusts",})
           formattedRowsClienti=[]
          for (let escursione of escursioni) {
        for (let cliente of dati) {
            if (escursione.excursionid === cliente.excursionid) {
                let dati = {
                    nome: cliente.excursioncustomername, id: cliente.excursioncustomerid,
                    costo: cliente.excursioncustomerpaid, pagato: cliente.excursioncustomeradvance, tipo: escursione.excursiontype,
                    data:escursione.excursiondatestart?convertDate(escursione.excursiondatestart).toISO({ includeOffset: false }):null,
                }
                formattedRowsClienti = [...formattedRowsClienti, dati]
            }
        }
    }
          $("#gridContainerClienti").dxDataGrid("instance").option("dataSource",formattedRowsClienti)

          }
          },
      onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        },
      onRowPrepared: function (e){
      if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));
            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo);

            if (!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
      },
      onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.id,
                azione:'delExcursionCust',
                return_data:false})
            if (richiesta) {
                const message = `${e.data.nome} eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerClienti',

                },}, "success", 1000);}
        },
      onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerClienti"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            $("#loadingOverlay").show()
            const dati2={"excursionid":e.data.excursionid,"excursioncustomeradvance": e.data.pagato,"excursioncustomername":e.data.nome,"excursioncustomerpaid":e.data.costo,"excursioncustomerphone":e.data.telefono,}
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.id,
                valori:dati2,
                azione:'setExcursionCust'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `${e.data.nome} modificato con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerClienti',

                },}, "success", 1000);

                }
          },

    });
    }, []);

return <div id="gridContainerClienti"/>
}

export default EscursioniCli
